function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import Icon from "./Icon";

var LogoOval = function LogoOval(props) {
  return React.createElement(Icon, _extends({
    color: "#004C47",
    width: "7",
    height: "7",
    viewBox: "0 0 7 7"
  }, props), React.createElement("path", {
    d: "M5.25067 5.25175C6.78959 3.71284 7.19287 1.62106 6.15144 0.579629C5.11001 -0.461803 3.01823 -0.0585142 1.47932 1.4804C-0.0595939 3.01931 -0.462882 5.11109 0.578549 6.15252C1.61998 7.19395 3.71176 6.79067 5.25067 5.25175Z"
  }));
};

export default LogoOval;